import { type StopAppointment } from 'core/appointments/domain/Appointment'

import { type Contact, type Facility } from '../../domain/Facility'
import { type Carrier } from '../../domain/Shipment'
import { OpenDockAppointmentDialog } from '../OpenDockAppointmentDialog/OpenDockAppointmentDialog'
import { OpenDockAppointmentDrawer } from '../OpenDockAppointmentDrawer/OpenDockAppointmentDrawer'
import { RegularAppointmentDrawer } from '../RegularAppointmentDrawer/RegularAppointmentDrawer'

type AppointmentDialogsProps = {
  showRegularAppointmentDrawer: boolean
  showOpenDockAppointmentDrawer: boolean
  facilityContact?: Partial<Contact>
  shipmentUUID: string
  stopIndex: number
  stopDate: string
  appointment?: StopAppointment
  appointmentDialogIsOpen: boolean
  openDockAppointmentIsOpen: boolean
  facility?: Partial<Facility>
  onClose: () => void
  onConfirm: () => void
  shipmentCarrier: Carrier
  shipperEmail?: string
}

export function AppointmentDialogs({
  showRegularAppointmentDrawer,
  showOpenDockAppointmentDrawer,
  facilityContact,
  shipmentUUID,
  stopIndex,
  stopDate,
  appointment,
  appointmentDialogIsOpen,
  openDockAppointmentIsOpen,
  facility,
  onClose,
  onConfirm,
  shipmentCarrier,
  shipperEmail,
}: AppointmentDialogsProps) {
  stopDate = stopDate || new Date().toISOString().slice(0, 10)

  if (showRegularAppointmentDrawer) {
    return (
      <RegularAppointmentDrawer
        facilityContact={facilityContact}
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        stopDate={stopDate}
        appointment={appointment}
        isOpen={appointmentDialogIsOpen}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    )
  }

  if (showOpenDockAppointmentDrawer) {
    return (
      <OpenDockAppointmentDrawer
        isOpen={openDockAppointmentIsOpen}
        onClose={onClose}
        stopDate={stopDate}
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        shipmentCarrier={shipmentCarrier}
        facilityTimezone={facility?.timezone}
        onConfirm={onConfirm}
      />
    )
  }

  return (
    <OpenDockAppointmentDialog
      shipmentUUID={shipmentUUID}
      stopIndex={stopIndex}
      stopDate={stopDate}
      appointment={appointment}
      facilityName={facility?.companyName}
      warehouseUUID={facility?.warehouseUuid}
      isOpen={openDockAppointmentIsOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      shipperEmail={shipperEmail}
    />
  )
}
